import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../components/spinner";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";
import { Mensaje, MensajeSiNo } from "../components/mensajes.js";

const CambiarEfiscal = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const efiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [select, setSelect] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [activo, setActivo] = useState(true);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "center" },
    { label: "AÑO", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idefiscal.includes(target.value) ||
              x.descriptor.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarEjercicioFiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let orden = "idefiscal";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var clase = [];
          for (let i = 0; i < response.data.length; i++) {
            clase.push({
              idefiscal: response.data[i].idefiscal,
              descriptor: response.data[i].descriptor,
              anio: response.data[i].anio,
              observaciones: response.data[i].observaciones,
              statusorg: response.data[i].statusorg,
              statuspresup: response.data[i].statuspresup,
              statuspuc: response.data[i].statuspuc,
              statuscat: response.data[i].statuscat,
              idorganizacion: response.data[i].idorganizacion,
              activo: response.data[i].activo,
            });
          }
          setRecords(clase);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setActivo(true);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarEfiscal = (index) => (event) => {
    var idefiscal = values[0].idefiscal;
    var descrip = values[0].descriptor;
    var anio = values[0].anio;
    var statusorg = values[0].statusorg;
    var statuspresup = values[0].statuspresup;
    var statuspuc = values[0].statuspuc;
    var statuscat = values[0].statuscat;

    blanquear();
    props.onHideSelectEfis(
      idefiscal,
      descrip,
      anio,
      statusorg,
      statuspresup,
      statuspuc,
      statuscat
    );
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    setSelect(parseInt(idefiscal));
    var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;
    var descriptor = recordsAfterPagingAndSorting()[index].descriptor;
    var anio = recordsAfterPagingAndSorting()[index].anio;
    var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
    var statusorg = recordsAfterPagingAndSorting()[index].statusorg;
    var statuspresup = recordsAfterPagingAndSorting()[index].statuspresup;
    var statuspuc = recordsAfterPagingAndSorting()[index].statuspuc;
    var statuscat = recordsAfterPagingAndSorting()[index].statuscat;
    var idorganizacion = recordsAfterPagingAndSorting()[index].idorganizacion;
    var activo = recordsAfterPagingAndSorting()[index].activo;

    var datos = [];
    datos.push({
      idefiscal,
      descriptor,
      anio,
      observaciones,
      statusorg,
      statuspresup,
      statuspuc,
      statuscat,
      idorganizacion,
      activo,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarEjercicioFiscal();
        setSelect(parseInt(efiscal));
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Cambio del Ejercicio Fiscal.</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-2 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control"
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={item.idefiscal}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      backgroundColor:
                        select === parseInt(item.idefiscal)
                          ? "lightskyblue"
                          : itemSelect === index
                          ? "lightskyblue"
                          : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idefiscal}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.descriptor}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.anio}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarEfiscal()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CambiarEfiscal;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoCambiarEfiscal.js